import React from 'react'

const DropdownItem = ({
    children,
    tag = 'div',
    className = '',
    widthAuto,
    ...rest
}) => {
    const classes = [
        'dropdown__list__item',
        className,
        widthAuto ? 'width-auto' : '',
    ].join(' ')

    const DynamicComponent = tag

    return (
        <DynamicComponent className={classes} {...rest}>
            {children}
        </DynamicComponent>
    )
}

export default DropdownItem
